/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react'
import parse from 'html-react-parser'
import styles from './styles/road-map.module.css'

// roadmapVideo
const Roadmap = ({ ourStory, ourStoryDetails, roadmapVideo }) => (
  <div className={styles.roadMapSection}>
    <div className={styles.sectionStory}>
      <div className={styles.storyHeading}>{parse(ourStory)}</div>
      <span className={styles.storyDetails}>{parse(ourStoryDetails)}</span>
    </div>
    <div className={styles.sectionImages}>
      <video
        src={roadmapVideo}
        loop
        autoPlay
        muted
        playsInline
        controls={false}
        className={styles.headerImage}
        style={{ width: '100%', height: 'auto' }}
      />
    </div>
  </div>
)
export default Roadmap
